module.exports = __webpack_public_path__ + "static/media/img2.53067638.jpg";